import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectPeopleArray } from '../../services/people/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

type State = *;

interface Props {
    excludePersonId?: number;
}

const selectExcludePersonId = (state: State, props: Props) =>
    props.excludePersonId && Number(props.excludePersonId);

const selectFilteredData = createDeepEqualSelector(
    [selectPeopleArray, selectExcludePersonId],
    (peopleArrayState, excludePersonIdState) =>
        peopleArrayState.filter(value => {
            if (!value.fullName) return false;
            return value.id !== excludePersonIdState;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'fullName')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, fullName }) => ({
            key: id,
            text: fullName,
            value: id
        }))
);

export { selectFilteredData, selectOrderedData, selectOptions };
